import { makeUrl } from "@uplift-ltd/strings";
import cx from "classnames";
import React from "react";
import { CourseProgressEnum } from "__generated__/globalTypes";
import Link from "components/common/Link";
import { COURSE_URL } from "constants/urls";
import { getMessageTextForCourse } from "helpers/courseDetails";
import { COURSE_PROGRESS_STEPS, getStepIndex, INITIAL_PROGRESS_STEP } from "helpers/courseProgress";
import { CourseIntersection } from "./types";
import styles from "./CourseProgressStepper.module.css";

interface CourseProgressStepperProps {
  course: CourseIntersection;
  page: CourseProgressEnum;
}

interface CourseProgressStepProps {
  isActive: boolean;
  isComplete: boolean;
  slug: string;
  page: string;
}

const CourseProgressStep: React.FC<CourseProgressStepProps> = ({
  children,
  isActive,
  isComplete,
  page,
  slug,
}) => (
  <li
    className={cx({
      [styles.isComplete]: isComplete,
      [styles.isActive]: isActive,
    })}
  >
    {isComplete || isActive ? (
      <Link href={makeUrl(COURSE_URL, { slug, page })}>{children}</Link>
    ) : (
      children
    )}
  </li>
);

const CourseProgressStepper: React.FC<CourseProgressStepperProps> = ({ course, page }) => {
  const currentStepIndex = getStepIndex(course?.courseProgress || INITIAL_PROGRESS_STEP);
  const pageIndex = getStepIndex(page);
  const messageText = getMessageTextForCourse(course);

  return (
    <div className={styles.root} role="complementary">
      <div className={styles.wrapper}>
        <div className={styles.progressHeading}>Activity Progress</div>
        <ol className={styles.progressStepper}>
          {COURSE_PROGRESS_STEPS.map(([step, label], i) => {
            return (
              <CourseProgressStep
                isActive={i === pageIndex}
                isComplete={i <= currentStepIndex}
                key={step}
                page={step.toLocaleLowerCase()}
                slug={course?.slug || ""}
              >
                {label}
              </CourseProgressStep>
            );
          })}
        </ol>
        <div className={styles.messageText}>{messageText}</div>
      </div>
    </div>
  );
};

export default CourseProgressStepper;
